const translations = {
    pastJobs: 'Past Jobs',
    upcomingJobs: 'Upcoming Jobs'
};

export default translations;
